export const normalizeHostname = (value: string) => {
  if (value.includes('://')) {
    return new URL(value).hostname.toLowerCase();
  }

  return value.replace(/:\d+$/, '').toLowerCase();
};

export const getParentDomain = (hostname: string) => {
  const hostnameParts = hostname.split('.');

  if (hostnameParts.length <= 2) {
    return '';
  }

  return hostnameParts.slice(1).join('.');
};

export const getNormalizedHosts = (values: unknown) => {
  if (!Array.isArray(values)) {
    return [] as string[];
  }

  return values
    .filter((value): value is string => typeof value === 'string' && Boolean(value))
    .map(normalizeHostname);
};
